export const MULTI_LEG_ORDER_TYPES = ["market", "limit"] as const;
export type MultiLegOrderType = (typeof MULTI_LEG_ORDER_TYPES)[number];

export const MULTI_LEG_TIME_IN_FORCE = ["day", "gtc"] as const;
export type MultiLegTimeInForce = (typeof MULTI_LEG_TIME_IN_FORCE)[number];

export const MULTI_LEG_ORDER_TYPE_OPTIONS: {
  value: MultiLegOrderType;
  label: string;
}[] = [
  { value: "market", label: "Market" },
  { value: "limit", label: "Limit" },
];
